import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.less';

export function InputWrap({
  hasError,
  error,
  children,
  className,
  icon,
  focused,
}) {
  const { t } = useTranslation();
  const showError = Boolean(hasError && error);
  return (
    <div className={`
      ${styles.root}
      ${showError ? styles.withError : ''}
    `}
    >
      <div
        className={`
          ${className}
          ${styles.inputWrap}
          ${showError ? styles.withError : ''}
          ${focused ? styles.withFocus : ''}
        `}
      >
        {icon && (
          <span className={styles.icon}>{icon}</span>
        )}
        {children}
      </div>
      <div className={styles.error}>
        {t(error)}
      </div>
    </div>
  );
}
